import { gql } from '@apollo/client'

export const Query = gql`
  query EditAccommodationContact($companyId: ID!, $accommodationId: ID!, $accommodationContactId: ID!) {
    accommodations(companyId: $companyId, filters: { idEq: $accommodationId }, first: 1) {
      nodes {
        id
        accommodationContacts(filters: { idEq: $accommodationContactId }, first: 1) {
          nodes {
            id
            user { id }
            name
            email
            phone
            contactType
          }
        }
      }
    }
  }
`
